<div class="zp-button-container">
  <button class="zp-button" [disabled]="disabled" [ngClass]="{'mini': !!options && options.size === 'mini'}" [ngStyle]="buttonStyles">
    <span class="zp-button-label" [ngStyle]="labelStyles">
      <ng-content></ng-content>
    </span>
  </button>
</div>
